import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, scrollTo, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';




import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';

import { usePlatformData } from '../../hooks/Platform';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {
  const {platform} = usePlatformData();
  return (
    <>
      <Capa>
        <div className="p50">
       <div style={{width: '100%', display: 'flex', flexWrap: 'wrap', alignContent: 'center', justifyContent: 'center'}}>
          
       <div style={{ maxWidth: '600px',width: '100%'}}>
          <img src={platform?.logo} style={{width: '100%'}}/>
          </div>
          <div style={{ maxWidth: '200px',width: '200px', display:'flex', alignItems: 'center'}}>
          <img style={{width:'100%'}} src={'/apoio/data.png'} />
          </div>
        
        </div>
        {platform?.homeTitle && <h2 className="defaultColor">{platform?.homeTitle}</h2>}
        {platform?.homeDescription && <p className="defaultColor" dangerouslySetInnerHTML={{__html: platform?.homeDescription}}/>}
          <div
            className=""
            style={{
              width: '100%',

              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
           { platform?.homeButtons && 

            platform?.homeButtons.map( buttonInfo => {
              return buttonInfo.status === "2" ?  buttonInfo.targetID ?
              <Link className="" to={buttonInfo.target} onClick={(e) => {
                e.preventDefault(); scrollTo(e,buttonInfo.targetID);
              }}>
              <Button type="button">{buttonInfo.title}</Button>
{' '}
            </Link>
              
              : <Link className="" to={buttonInfo.target}>
              <Button type="button">{buttonInfo.title}</Button>
{' '}
            </Link> : <></>
            })
           
           }


          </div>
     
          <SponsorsList/>
        </div>

     
      </Capa>
    </>
  );
};
export default Home;
